import applogger from '@applogger'
const FingerprintJS = () => import(/* webpackChunkName: 'fingerprint' */ '@fingerprintjs/fingerprintjs')
const inBrowser = () => typeof window !== 'undefined'

export default function() {
  if (!inBrowser()) {
    return Promise.resolve('non-browser-fingerprint')
  }
  const exec = function(resolve) {
    FingerprintJS()
      .then(fp => fp.load())
      .then(fp => fp.get())
      .then(result => {
        resolve(result.visitorId)
      })
  }
  return new Promise((resolve, reject) => {
    try {
      if (window.requestIdleCallback) {
        requestIdleCallback(function() {
          exec(resolve)
        })
      }
      else {
        setTimeout(function() {
          exec(resolve)
        }, 500)
      }
    }
    catch (err) {
      applogger.error(`Error generating Browser fingerprint: ${err.message}`)
    }
  })
}
